"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const TreeNodeContainer = ({ isOpen, groupId, children }) => {
    const treeNodeContainerClasses = (0, classnames_1.default)('TreeNodeContainer', 'user-select-none', isOpen && 'open');
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: treeNodeContainerClasses, "data-id": groupId }, { children: children })));
};
TreeNodeContainer.displayName = 'TreeNodeContainer';
TreeNodeContainer.propTypes = {
    maxHeight: prop_types_1.default.number,
};
exports.default = TreeNodeContainer;
